import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[IPOnly]',
  standalone: true,
})
export class IPOnlyDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  private static readonly allowedKeys = new Set([
    'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
    'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight',
  ]);

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;

    if (
      IPOnlyDirective.allowedKeys.has(key) ||
      (event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(key.toLowerCase())
    ) {
      return;
    }

    if (!/[\d.]/.test(key)) {
      event.preventDefault();
      return;
    }

    const input: HTMLInputElement = this.el.nativeElement;
    const currentValue = input.value;
    const selectionStart = input.selectionStart ?? currentValue.length;
    const selectionEnd = input.selectionEnd ?? currentValue.length;

    const nextValue =
      currentValue.substring(0, selectionStart) +
      key +
      currentValue.substring(selectionEnd);

    if (!this.isPartialIPv4(nextValue)) {
      event.preventDefault();
    }
  }

  private isPartialIPv4(value: string): boolean {
    const octets = value.split('.');

    if (octets.length > 4) return false;

    for (const octet of octets) {
      if (octet === '') continue;

      const num = Number(octet);
      if (!/^\d{1,3}$/.test(octet) || num < 0 || num > 255) return false;
      if (octet.length > 1 && octet.startsWith('0')) return false;
    }

    return true;
  }
}
